import * as React from 'react';
import TextField from 'material-ui/TextField';
import DatePicker from 'material-ui/DatePicker';
import { black } from 'material-ui/styles/colors';
import Phone from 'react-phone-number-input';
import {
  Member
} from '../members/members.types';
import {
  getLocalDate
} from '../util/date-util';
import { MmsColor } from 'src/app/app.const';

const fieldStyles = {
  rootStyle: {
    cursor: 'text'
  },
  textStyle: {
    color: black
  },
  dividerStyle: {
    backgroundColor: 'rgb(0, 188, 212)'
  }
};

type Props = {
  readonly member: Member
};

type States = {
};

class AttendanceMemberDetailsComponent extends React.Component<Props, States> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const {
      member
    } = this.props;

    return (
      <div className="ph3 bg-white pb-3 pt-3 text-center">
        <div
          style={{ fontSize: '23pt' }}
        >
          <strong>
            {member.firstName} {member.lastName}
            {
              (member.initial) ? ' (' + member.initial + ')' : null
            }
          </strong>
        </div>
        <div className="col-12 text-center">
          <Phone
            className="profilePhoneNumber"
            countries={['CA']}
            value={member.mobile1}
            convertToNational={true}
            inputStyle={{
              backgroundColor: 'inherit',
              borderBottom: '0px',
              height: '40px',
              fontSize: '18pt',
              color: MmsColor.MmsBlue,
              width: (member.mobile1) ? member.mobile1.length + 'ch' : '0ch'
            }}
            disabled={true}
            onChange={Function()}
          />
        </div>
      </div>
    );
  }
}

export default AttendanceMemberDetailsComponent;


// WEBPACK FOOTER //
// ./src/attendance/AttendanceMemberDetailsComponent.tsx